<template>
  <div class="page">
    <div class="title">
      快捷创建店铺
    </div>
    <!-- 创建店铺 -->
    <van-form>
      <van-cell-group>
        <van-field
          v-model="shopName"
          required
          label="店铺名称"
          placeholder="请输入您的店铺名称"
          @blur="shopNameBlue"
          @input="shopMsgOff"
          :error-message="msgError"
          :style="msgError ? 'margin-bottom: 1px' : '25px'"
        />
        <van-field
          readonly
          required
          clickable
          label="主营品类"
          :value="category"
          placeholder="请选择"
          @click="showCategoryOn"
          right-icon="arrow"
        />
        <van-popup v-model="showCategory" position="bottom">
          <van-picker
            show-toolbar
            :columns="columnsCategory"
            @cancel="showCategory = false"
            @confirm="onConfirmCategory"
          />
        </van-popup>
        <van-field
          class="last-field"
          readonly
          required
          clickable
          label="店铺地址"
          :value="address"
          placeholder="请选择"
          @click="showCityListOn"
          right-icon="arrow"
        />
        <van-popup v-model="showAddress" position="bottom">
          <van-area
            :area-list="areaList"
            @confirm="onConfirmAddress"
            @cancel="showAddress = false"
          />
        </van-popup>

        <van-field
          required
          v-model="detailsAdd"
          placeholder="请填写店铺详细地址"
        />
      </van-cell-group>

      <div style="margin: 16px;">
        <van-button round block type="info" @click="onSubmit(-1)">
          下一步
        </van-button>
      </div>
    </van-form>
    <!-- 公共组件 底部 -->
    <bt_logo></bt_logo>
  </div>
</template>

<script>
// @ is an alias to /src
// 引入公共组件
import btLogo from '../components/btLogo'
import { Dialog, Toast } from 'vant'
import { getStoreNameIsAvailable, getAvailableStoreLinks } from '@/api/store'
import store from '@/vuex/store'
export default {
  data() {
    return {
      shopName: '', // 店铺名称
      category: '', // 品类
      address: '', // 地址
      template_id: -1,
      business_id: '',
      business_pattern_id: 1, //经营模式id
      store_type: 0,
      short_url: '',
      detailsAdd: '', // 详细地址
      areaList: {}, // 省市区列表
      categoryList: [], // 主营类目
      showAddress: false,
      showCategory: false,
      keyValue: '',
      // 测试品类
      columnsCategory: [],
      // 获取地址的id
      addressId: [],
      msgError: '' // 店铺名称错误提示
      // detailError: '' // 详细地址错误提示
    }
  },
  created() {
    // 获取类目列表
    this.getGoodsCategoryList()
    // 获取省份列表
    this.getCityList()
  },
  methods: {
    showCategoryOn() {
      // 打开弹框
      this.showCategory = true
    },
    showCityListOn() {
      // 打开弹框
      this.showAddress = true
    },
    // 获取主营类目
    getCategoryList(parentid) {
      let _this = this
      return _this.$api.getGoodsCategoryList({
        parentid
      })
    },
    // 获取主营类目列表
    getGoodsCategoryList() {
      let _this = this
      _this.getCategoryList(-1).then(res => {
        console.log(res, '123123')
        if (res.code !== 200) {
          return Toast.fail('获取主营类目列表失败')
        }

        let list = _this.listChangeKey(res.response, [
          {
            old: 'id',
            new: 'value'
          },
          {
            old: 'name',
            new: 'label'
          }
        ])
        // console.log(list, 'listlistlist')
        _this.categoryList = _this.listToTree(list, 0)
        console.log(_this.categoryList, '==============')
        if (
          JSON.stringify(_this.categoryList) !=
          sessionStorage.getItem('categoryList')
        ) {
          sessionStorage.setItem(
            'categoryList',
            JSON.stringify(_this.categoryList)
          )
        }
        let columns = []
        let children = []
        let children2 = []
        _this.categoryList.forEach(item1 => {
          children = []
          if (item1.children.length == 0) {
            columns.push({
              text: item1.label,
              children: [{ text: '' }]
            })
            return false
          }

          item1.children.forEach(item2 => {
            if(item2.children.length == 0) {
              children.push({
                text: item2.label,
                children: [{ text: '' }]
              })
            }else {
              item2.children.forEach(item3 => {
                children2.push({
                  text: item3.label,
                  children: null,
                })
              })
              children.push({
                text: item2.label,
                children: children2
              })
            }
          })

          columns.push({
            text: item1.label,
            children
          })
        })
        _this.columnsCategory = columns
        console.log('columns: ', columns)
      })
    },
    shopNameBlue(e) {
      if (e.target.value.trim() == '') {
        // Toast.fail('店铺名称不能为空')
        this.msgError = '店铺名称不能为空'
      } else {
        getStoreNameIsAvailable({
          name: this.shopName
        }).then(res => {
          console.log(res)
          if (res.code == 200 && !res.response.state) {
            // return Dialog.confirm({
            //   title: '提示',
            //   message: res.response.msg
            // })
            return (this.msgError = res.response.msg)
          }
        })
      }
      // console.log()
    },
    // 当input中的值为空时 清空提示信息
    shopMsgOff(e) {
      if (e == '') {
        this.msgError = ''
      }
      this.msgError = ''
    },
    // 表单提交
    onSubmit(template_id) {
      // if()
      // 检测店铺是否存在
      getStoreNameIsAvailable({
        name: this.shopName
      }).then(res => {
        console.log(res)
        if (res.code == 200 && !res.response.state) {
          return Dialog.confirm({
            title: '提示',
            message: res.response.msg
          })
        }
        getAvailableStoreLinks({
          title: this.shopName
        }).then(res => {
          // console.log('res: =====', res)
          if (res.code == 200 && !res.response.state) {
            return Dialog.confirm({
              title: '提示',
              message: res.response.msg
            })
          }
          if (res.response.state) {
            if (res.response.suggest.length >= 6) {
              this.short_url = res.response.suggest
            } else {
              this.short_url =
                res.response.suggest +
                (Date.parse(new Date()) + '').slice(0, 10)
            }
            // 请求参数
            let parmas = {
              name: this.shopName,
              store_type: this.store_type,
              business_id: this.business_id,
              business_pattern_id: 1,
              template_id: -1,
              short_url: this.short_url,
              address_value: {
                province_name: this.addressId[0],
                city_name: this.addressId[1],
                area_name: this.addressId[2],
                address: this.detailsAdd
              }
            }
            localStorage.setItem('params', JSON.stringify(parmas))
            // }
            if (this.category == '') {
              // return Toast.fail('主营品类或店铺地址不能为空')
              return Toast('主营品类不能为空')
            }
            if (this.address == '') {
              return Toast('店铺地址不能为空')
            }
            if (this.detailsAdd.trim() == '') {
              return Toast('请填写店铺详细地址')
            }
            this.$router.push({
              name: 'select'
            })
          }
        })
      })
    },
    // 选择主营品类
    onConfirmCategory(value) {
      let _this = this
      this.category1 = value
      if (value.length == 2 && value[1] == '') {
        _this.category = value[0]
        _this.business_id = _this.categoryList.find(v => v.label == value[0]).value
      } else {
        if(value.length == 3 && value[2] == '') {
          value.splice(value.length - 1, 1)
        }
        _this.category = value.join(' / ')
        _this.categoryList.forEach(v => {
          if(v.children.length > 0) {
            v.children.forEach(v2 => {
              if(v2.label == value[1]) {
                _this.business_id = v2.value
              }
              if(v2.children.length > 0) {
                v2.children.forEach(v3 => {
                  if(v3.label == value[2]) {
                    _this.business_id = v3.value
                  }
                })
              }
              
            })
          }
        })
      }
      // console.log(_this.business_id, '::::keys----line 309')
      this.showCategory = false
    },

    //得到所有的省市区列表
    async getCityList(provinceId) {
      let cityList = localStorage.getItem('areaList')
      if (cityList) {
        this.areaList = JSON.parse(cityList)
        console.log(this.areaList)
        return false
      }
      return this.$api.getregions().then(res => {
        if (res.code !== 200) {
          return Toast.fail('获取省市区列表失败')
        }

        let areaList = {
          province_list: {},
          city_list: {},
          county_list: {}
        }
        let allAreaData = res.response
        console.log(allAreaData, '地址')
        allAreaData.provinces.forEach(val => {
          areaList.province_list[
            val.unique
          ] = `${val.title}<i style='display:none;'>-${val.id}^</i>`
        }) // 省
        allAreaData.citys.forEach(val => {
          areaList.city_list[
            val.unique
          ] = `${val.title}<i style='display:none;'>-${val.id}^</i>`
        }) // 市
        allAreaData.districts.forEach(val => {
          areaList.county_list[
            val.unique
          ] = `${val.title}<i style='display:none;'>-${val.id}^</i>`
        }) // 区
        this.areaList = areaList

        // 将所有省市区存到localStorage中
        localStorage.setItem('areaList', JSON.stringify(areaList))
      })
    },
    // 选择店铺地址
    onConfirmAddress(value) {
      console.log(value)
      let addressName = []
      let addressNameId = []
      let addressNameItem = ''
      let addressNameItemId = ''
      value.forEach(item => {
        addressNameItem = item.name.split('<')[0]
        addressName.push(addressNameItem)
        addressNameItemId = item.name.split('-')[1].split('^')[0]
        addressNameId.push(addressNameItemId)
      })
      console.log(addressName)
      console.log(addressNameId)
      this.address1 = addressName
      this.address = addressName.join(' / ')
      this.addressId = addressNameId
      this.showAddress = false
    }
  },
  components: {
    bt_logo: btLogo
  }
}
</script>
<style lang="css" scoped>
.page {
  height: 100%;
  padding: 62px 37px 0 36px;
  box-sizing: border-box;
}
.title {
  margin: 0 0 70px 0;
  font-size: 23px;
  font-family: PingFang-SC-Bold;
  color: #333;
}
.van-field {
  margin-bottom: 25px;
  padding: 5px 22px !important;
}
.last-field {
  margin-bottom: 15px;
}
.van-button--info {
  color: #fff;
  background-color: #3d6eff;
  border: 0.02667rem solid #3d6eff;
}
/* .van-button {
  margin-top: 37px;
} */
</style>
